import React from "react";
import ReactDOM from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import { ToastContainer } from "react-toastify";
import App from "./App";
import "./App.scss";
import SessionLimiter from "./components/Auth/SessionLimiter";
import { AuthProvider } from "./context/AuthContext";
import store from "./redux/store";
import { initialseIndesignService } from "./utils/inDesignServices";
// Typing for the module's hot property
interface NodeModule {
  hot?: {
    accept: (path: string, callback: () => void) => void;
  };
}

declare const module: NodeModule;

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Failed to find the root element");
}

const root = ReactDOM.createRoot(rootElement as HTMLElement);

document.addEventListener("DOMContentLoaded", () => {
  const csInterface = new window.CSInterface();
  if (csInterface.hostEnvironment) {
    initialseIndesignService();
  } else {
    // console.log("Not in host environment");
  }
});

// Function to render the App component
const render = (Component: React.ComponentType) => {
  root.render(
    <React.StrictMode>
      <ReduxProvider store={store}>
        <AuthProvider>
          <SessionLimiter>
            <Component />
            <ToastContainer />
          </SessionLimiter>
        </AuthProvider>
      </ReduxProvider>
    </React.StrictMode>
  );
};

// Initial render of the App component
render(App);

// Handle hot module replacement
if (module.hot) {
  module.hot.accept("./App", () => {
    const NextApp = require("./App").default;
    render(NextApp);
  });
}
